<app-header></app-header>

<div class="container-xxl">

<section class="banner d-flex justify-content-center align-items-center text-center">
  <div class="content" data-aos="zoom-in" data-aos-duration="2000">
    <div class="title">
      <span>الأقسام</span>
    </div>
  
    <div class="links">
      <a class="text-decoration-none" href="/home"> الرئيسية </a>
      <span>/ الأقسام </span>
    </div>
  </div>
</section>

<div class="search mt-5" data-aos="fade-left" data-aos-duration="2000">
  <div class="container">
    <div class="group">
      <form>
        <input type="text" class="form-control" placeholder="ابحث عن اسم القســـم " #myInput style="width: 400px;">
        <br>
        <button class="search-btn btn btn-warning" (click)="searchByCategoryTitle(myInput.value)">ابحـــث</button>
      </form>
    </div> 
  </div>
</div>

<section class="all-categories">
  <div class="container-xxl">         
    <div class="row d-flex justify-content-center align-items-center mb-5">  
      <div  *ngFor="let category of renderCategories">
        <a class="content text-center" routerLink="/getCategoryById/{{category._id}}" data-aos="flip-right" data-aos-duration="2000">

          <div class="image d-flex justify-content-center align-items-center">
            <img class="" src="https://khairokom-uploadfiles.azurewebsites.net/files/{{category.Image}}" alt="تحميل الصـــورة">
          </div>

          <div class="title mt-4">
            <h3>{{category.Title}}</h3>
          </div>                    

          <!-- <div class="description mt-2">
            <p>{{category.Description}}</p>          
          </div> -->
          
          <!-- <div class="details mb-4">
            <a class="text-decoration-none">عرض التفاصيل <i class="fas fa-arrow-left"></i></a>                      
          </div> -->

        </a>        
      </div>

    </div>
  
    {{errorMsg}}
  </div>
</section>
</div>
  <app-footer></app-footer>